<template>
  <v-app>
    <v-app-bar app color="primary">
      <v-row align="center" no-gutters justify="center">
        <v-col align="center">
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <v-toolbar-title class="text-center"
              >FleeTOP Digital Profile Card
            </v-toolbar-title>
          </template>
          <template v-else>
            <v-toolbar-title class="text-center"
              >GlobalMediaHubli Digital Profile Card
            </v-toolbar-title>
          </template>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-toolbar-title class="text-center"
            ><span> Total License Available = {{ this.license }} </span>
          </v-toolbar-title>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content justify="center">
      <v-card width="auto" class="mx-auto mt-5">
        <v-card-title>
          <h1 class="display1">Administrator</h1>
          <v-spacer> </v-spacer>
          <h2 class="display1">Generate OrderID and update Database</h2>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>

            <v-text-field
              v-model="orderid"
              :rules="orderidRules"
              label="Generated OrderID"
              required
            ></v-text-field>

            <v-text-field
              v-model="addedby"
              :rules="addedbyRules"
              label="OrderID Added By"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" :disabled="!valid" @click="updateOrderID"
            >Update OrderID</v-btn
          >
          <v-spacer> </v-spacer>
          <v-btn color="success" @click="signOut">SignOut</v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <template v-if="$store.state.build_dealer_config === 'Chespik'">
          <v-card-title>
            FleeTOP OrderID details
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </template>
        <template v-else>
          <v-card-title>
            GlobalMediaHubli OrderID details
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </template>
        <v-data-table
          :headers="headers"
          :items="databasevalues"
          :search="search"
        ></v-data-table>
      </v-card>
    </v-content>

    <v-footer dark padless color="primary lighten-1">
      <v-card tile class="primary lighten-1 white--text" width="100%">
        <v-row align="center" no-gutters justify="center">
          <v-col align="center">
            <v-card-text class="black--text pt-0">
              <span class="mr-1">Powered by</span>
              <template v-if="$store.state.build_dealer_config === 'Chespik'">
                <a href="http://www.fleetop.net" target="_blank">
                  <strong class="white--text pt-0">FleeTOP Technologies</strong>
                </a>
              </template>
              <template v-else>
                <a href="http://www.globalmediahubli.com" target="_blank">
                  <strong class="white--text pt-0">Global Media Hubli</strong>
                </a>
              </template>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import firebase from "firebase";

export default {
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    orderid: null,
    orderidRules: [
      v => !!v || "orderid is required",
      v => (v && v.length >= 6) || "orderid must be atleast 6 characters"
    ],
    addedby: null,
    addedbyRules: [v => !!v || "Added By is required"],
    error: null,
    user: { email: null, orderid: null, dateadded: null, addedby: null },
    search: "",
    headers: [
      {
        text: "E-Mail",
        align: "start",
        sortable: false,
        value: "email"
      },
      { text: "OrderID", value: "orderid" },
      { text: "Date Added", value: "dateadded" },
      { text: "Added By", value: "addedby" }
    ],
    databasevalues: [null],
    emailexists: false,
    orderidexists: false,
    items: [
      { title: "User Details" },
      { title: "Subscription Details" },
      { title: "Payment Details" },
      { title: "Delete User" }
    ],
    license: 0
  }),
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm(
      "Do you really want to leave? you have unsaved changes!"
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  },

  created() {
    this.checkLicenseAvailable();
    this.updatetable();
  },

  methods: {
    updateOrderID() {
      if (this.license > 0) {
        this.validate();
        if (this.valid === true) {
          this.checkifemailalreadyexistsindatabase();
          if (this.emailexists === false && this.orderidexists === false) {
            this.error = null;

            var currentdate = new Date();
            this.user.email = this.email;
            this.user.orderid = this.orderid;
            this.user.dateadded = currentdate.toISOString();
            this.user.addedby = this.addedby;
            let key = null;
            let nolicense = this.license;
            return firebase
              .database()
              .ref("OrderID")
              .push(this.user)
              .then(data => {
                key = data.key;
                console.log("this.license before update ", this.license);
                this.license = this.license - 1;
                console.log("this.license after update ", this.license);
                return firebase
                  .database()
                  .ref("LicenseCount")
                  .update({ Count: this.license });
              })
              .then(() => {
                alert(" OrderID added to database successfully !!");
                this.updatetable();
              })
              .catch(() => {
                console.log(
                  "Server ERROR..OrderID not added , Please Re-Login & try again"
                );
                alert("Server ERROR. , Please Re-Login & try again");

                if (nolicense !== this.license) {
                  this.license = this.license + 1;
                  firebase
                    .database()
                    .ref("LicenseCount")
                    .update({ Count: this.license });
                }
                console.log("Before removing orderid ....");
                if (key !== null) {
                  firebase
                    .database()
                    .ref("OrderID/" + key)
                    .remove()
                    .then(() => {
                      console.log(
                        "orderid delete  successful here ",
                        this.license
                      );
                      this.signOut();
                    });
                }
              });
          } else {
            alert(
              " Security ERROR !!!Entered email id /Orderid already exists in database ..please verify!!"
            );
            this.emailexists = false;
            this.orderidexists = false;
          }
        }
      } else {
        alert(
          " Security ERROR !!!No Licenses are availabel to  add new Order!! , Please contact FleeTOP Technologies to buy more licenses"
        );
        this.emailexists = false;
        this.orderidexists = false;
        this.signOut();
      }
    },
    checkifemailalreadyexistsindatabase() {
      this.databasevalues.forEach(item => this.checkemailmatches(item));
    },
    checkemailmatches(item) {
      if (item !== null) {
        if (item.email === this.email) {
          this.emailexists = true;
        }
        if (item.orderid === this.orderid) {
          this.orderidexists = true;
        }
      }
    },

    validate() {
      if (
        this.email !== null &&
        this.orderid !== null &&
        this.addedby !== null
      ) {
        this.valid = true;
        return this.valid;
      } else {
        this.valid = false;
        alert("Please enter values for all mandatory fields ");
        return this.valid;
      }
    },
    updatetable() {
      var db = firebase.database();
      var ref = db.ref("OrderID").orderByChild("dateadded");

      ref.once("value", snapshot => {
        if (snapshot.exists()) {
          var name = snapshot.val();
          name = Object.values(name);

          this.databasevalues = name;
        } else {
          this.error =
            "There is no data in database with orderid = " + this.search;
        }
      });
    },

    checkLicenseAvailable() {
      var licensedb = firebase.database();
      var ref = licensedb.ref("LicenseCount");

      ref.once("value", snapshot => {
        if (snapshot.exists()) {
          var name = snapshot.val();
          console.log("name =", name);
          name = Object.values(name);
          console.log("name =", name);
          this.license = name[0];
          console.log("this.license =", this.license);
        } else {
          alert(
            "Server ERROR!!, Not able to retrieve license from server, please try after sometime "
          );

          this.signOut();
        }
      });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "Home"
          });
        });
    }
    /* menuAction(index) {

      if (index === 1) this.$router.replace({ name: "UserDetails" });
      else if (index === 2) this.$router.replace({ name: "UserDetails" });
      else if (index === 3) this.$router.replace({ name: "UserDetails" });
      else if (index === 4) this.$router.replace({ name: "UserDetails" });
    }*/
  }
};
</script>
